import Vue from 'vue';
import Router from 'vue-router';

// import {mapGetters} from 'vuex';
// import {USER_REQUEST} from "../store/actions/user";

import store from "@/utils/store";

import KappLoading from "../../components/KappLoading";

import KappMain from "../../components/KappMain";
import KappAktuelles from "../../pages/KappAktuelles";
import KappProfile from "../../pages/KappProfile/KappProfile";
import KappInfocenter from "../../pages/KappInfocenter";
import KappKalender from "../../pages/KappKalender";
import KappKontakte from "../../pages/KappKontakte";
import KappNachrichten from "../../pages/KappNachrichten";
// import KappNewsSingle from "../../components/blocks/KappNewsSingle";
import KappLogin from "../../components/KappLogin";
import KappNotfall from "../../pages/KappNotfall";
import FileDownload from "../../components/plugins/FileDownload";
import KappSocialMedia from '../../pages/KappSocialMedia';
import KappBarometer from '../../pages/KappBarometer';
// import Gallery from '../../components/blocks/Gallery';
import KappDashboard from '../../pages/KappDashboard';
import KappDashboardList from '../../components/subparts/KappDashboardList';
import KappDashboardNew from '../../components/subparts/KappDashboardNew';
// import KappImpressions from '../../components/subparts/KappImpressions';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Loading',
            component: KappLoading,
            meta: {
                title: 'Kassecker'
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: KappLogin,
            meta: {
                title: 'Login - Kassecker',
                // analytics: {
                //     pageviewTemplate( route ) {
                //         return {
                //             title: 'Login',
                //             page: route.path
                //         };
                //     }
                // }
            }
        },
        {
            path: '/index',
            name: 'MainView',
            component: KappMain,
            meta: {
                title: 'Kassecker',
                authRequired: true,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Navigation',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/neuigkeiten',
            name: 'Neuigkeiten',
            component: KappAktuelles,
            meta: {
                uid: 2,
                authRequired: true,
                title: 'Neuigkeiten',
                image: require('@/assets/images/icons/ic_aktuelles.svg'),
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Neuigkeiten',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/aktuelles',
            name: 'Schwarzes Brett',
            component: KappDashboard,
            meta: {
                uid: 34,
                authRequired: true,
                title: 'Schwarzes Brett',
                image: require('@/assets/images/icons/ic_dashboard.svg'),
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Schwarzes Brett',
                            page: route.path
                        };
                    }
                }
            },
            children: [
                {
                    path: 'liste',
                    name: 'AktuellesListe',
                    component: KappDashboardList,
                    meta: {
                        uid: 34,
                        authRequired: true,
                        title: 'Schwarzes Brett',
                        createPost: 'AktuellesNew',
                        image: require('@/assets/images/icons/ic_dashboard.svg')
                    }
                },
                {
                    path: 'neu',
                    name: 'AktuellesNew',
                    component: KappDashboardNew,
                    meta: {
                        uid: 34,
                        authRequired: true,
                        title: 'BEITRAG VERFASSEN',
                        image: require('@/assets/images/icons/ic_dashboard.svg')
                    }
                }
            ]
        },
        {
            path: '/impressionen',
            name: 'Impressionen',
            component: KappDashboard,
            meta: {
                uid: 35,
                authRequired: true,
                title: 'Impressionen',
                image: require('@/assets/images/icons/ic_dashboard.svg'),
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Impressionen',
                            page: route.path
                        };
                    }
                }
            },
            children: [
                {
                    path: 'liste',
                    name: 'ImpressionsList',
                    component: KappDashboardList,
                    meta: {
                        uid: 35,
                        authRequired: true,
                        title: 'eure Beiträge',
                        createPost: 'ImpressionsNew',
                        image: require('@/assets/images/icons/ic_dashboard.svg'),
                    }
                },
                {
                    path: 'neu',
                    name: 'ImpressionsNew',
                    component: KappDashboardNew,
                    meta: {
                        uid: 35,
                        authRequired: true,
                        title: 'Neues Bild',
                        image: require('@/assets/images/icons/ic_dashboard.svg'),
                    }
                }
            ]
        },
        // {
        //     path: '/aktuelles/:articleUid',
        //     name: 'AktuellesSingle',
        //     params: {articleUid: 0},
        //     component: KappNewsSingle,
        //     props: true,
        //     meta: {
        //         authRequired: true
        //     }
        // },



        {
            path: '/kontakte',
            name: 'Kontakte',
            component: KappKontakte,
            meta: {
                uid: 12,
                title: 'Kontakte',
                image: require('@/assets/images/icons/ic_kontakte.svg'),
                authRequired: true,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Kontakte',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/kalender',
            name: 'Kalender',
            component: KappKalender,
            meta: {
                uid: 13,
                title: 'Kalender',
                image: require('@/assets/images/icons/ic_kalender.svg'),
                authRequired: true,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Kalender',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/infocenter/:slug/',
            name: 'Infocenter',
            component: KappInfocenter,
            params: {slug: 'alles'},
            meta: {
                uid: 4,
                title: 'Infocenter',
                image: require('@/assets/images/icons/ic_infocenter.svg'),
                authRequired: true,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Infocenter',
                            page: route.path
                        };
                    }
                }
            },
            children: [

            ]
        },
        {
            path: 'socialmedia',
            name: 'SocialMedia',
            // name : 'InstagramFeed',
            component: KappSocialMedia,
            title: 'Social Media',
            meta: {
                uid: 999,
                title: 'Social Media',
                image: require('@/assets/images/icons/ic_instagram.svg'),
                authRequired: true,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Social Media',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/quartals-barometer',
            name: 'Barometer',
            component: KappBarometer,
            meta: {
                uid: 10,
                title: 'Barometer',
                image: require('@/assets/images/icons/ic_barometer.svg'),
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Barometer',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/nachrichten',
            name: 'Nachrichten',
            component: KappNachrichten,
            meta: {
                uid: 11,
                title: 'Nachrichten',
                image: require('@/assets/images/icons/ic_chats.svg'),
                authRequired: true
            }
        },
        {
            path: '/notfall',
            name: 'Notfall',
            component: KappNotfall,
            meta: {
                uid: 16,
                title: 'Notfall',
                image: require('@/assets/images/icons/ic_notfall.svg'),
                authRequired: false,
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Notfall',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/account',
            name: 'Profile',
            component: KappProfile,
            meta: {
                authRequired: true,
                title: '',
                image: '',
                analytics: {
                    pageviewTemplate( route ) {
                        return {
                            title: 'Infocenter',
                            page: route.path
                        };
                    }
                }
            }
        },
        {
            path: '/download/:file',
            name: 'Download',
            component: FileDownload,
            params: {slug: 'file'},
            meta: {
                title: 'Datei'
            }
        },


    ]

});

router.beforeEach(
    function ( to, from, next ) {

        // console.log( 'false === to.meta.authRequired ',
        //     false === to.meta.authRequired );
        // console.log( '( to.meta.authRequired || false ) && store.getters.isAuthenticated',
        //     ( to.meta.authRequired || false ) && store.getters.isAuthenticated );
        // console.log( 'to.meta.authRequired && ! store.getters.isAuthenticated',
        //     (to.meta.authRequired || false) && ! store.getters.isAuthenticated );

        if ( to.name === 'Login' && store.getters.isAuthenticated ) {
            next({name: 'MainView'});
        }

        if ( false === to.meta.authRequired ) next();

        // console.log( 'router - authenticated: ', store.getters.isAuthenticated );
        // console.log( ( to.meta.authRequired || false ) , store.getters.isAuthenticated );
        if ( (to.meta.authRequired || false) && store.getters.isAuthenticated ) {

            next();
            // console.log( store.getters.isAuthenticated );
        }
        else if ( to.meta.authRequired && !store.getters.isAuthenticated ) {
            next({name: 'Login'});
        }

        next();
    });


export default router;



// WEBPACK FOOTER //
// ./src/utils/router/index.js